import React from "react"
import types from "prop-types"
import { MenuButton } from "@szhsin/react-menu"
import { useDispatch } from "react-redux"
import { deleteReport } from "reduxSlices/reportIndexSlice"
import { TASK_REPORT_TYPE } from "utils/reportHelpers"
import { redirectTo, taskReportEditPath } from "utils/routeHelpers"
import ExpandMenu, { ExpandMenuItem } from "shared/ExpandMenu"

const TaskReportMenu = ({ report }) => {
  const dispatch = useDispatch()

  const { editable, deletable } = report

  const goToReportEditPage = () => redirectTo(taskReportEditPath(report.id))

  const removeReport = () => {
    if (window.confirm("Are you sure you want to delete this report?")) {
      dispatch(deleteReport({ reportType: TASK_REPORT_TYPE, reportId: report.id }))
    }
  }

  return (
    <ExpandMenu
      expandMenuComponent={(
        <MenuButton className="circular-icon-button p-2.5" aria-label="show menu">
          <svg className="!w-4 !h-4" aria-hidden><use xlinkHref="#ellipsis" /></svg>
        </MenuButton>
      )}
    >
      {
        editable && (
          <ExpandMenuItem onClick={goToReportEditPage}>
            Edit
          </ExpandMenuItem>
        )
      }
      {
        deletable && (
          <ExpandMenuItem onClick={removeReport}>
            Delete
          </ExpandMenuItem>
        )
      }
    </ExpandMenu>
  )
}

TaskReportMenu.propTypes = {
  report: types.objectOf(types.any).isRequired,
}

export default TaskReportMenu
